import enterpriseClient from "./enterpriseClient";

/**
 * Onboard user via create link.
 * Endpoint: POST /api/user-onboard/by-create-link
 *
 * @param {Object} payload - User onboarding data payload
 * @returns {Promise<any>} Server response data
 */
export const userOnboardByCreateLinkAPI = async (payload) => {
  try {
    const response = await enterpriseClient.post(
      "/api/user-onboard/by-create-link",
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Error in userOnboardByCreateLink:", error);
    return Promise.reject(error?.response?.data || error);
  }
};

/**
 * Alias for backward compatibility
 */
export const userOnboardByCreateLink = userOnboardByCreateLinkAPI;

export default userOnboardByCreateLinkAPI;
